import { useTheme, type Theme } from '../lib/theme';

interface ThemeToggleProps {
  className?: string;
  size?: 'md' | 'sm';
}
export default function ThemeToggle(props: ThemeToggleProps) {
  const { theme, toggle } = useTheme();
  return <ThemeToggleButton {...props} theme={theme} toggle={toggle} />;
}

/** Use an existing owner where multiple controls share the same surface. */
export function ThemeToggleButton({ className = '', size = 'md', theme, toggle }: ThemeToggleProps & {
  theme: Theme; toggle: () => void;
}) {
  const isDark = theme === 'dark';
  const box = size === 'sm' ? 'w-7 h-7' : 'w-9 h-9';
  const icon = size === 'sm' ? 14 : 16;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      className={`relative ${box} rounded-full border border-line text-fg/70 hover:text-fg hover:border-fg/40 transition-colors duration-300 ${className}`}
    >
      <span className="absolute inset-0 flex items-center justify-center">
        {isDark ? <MoonIcon size={icon} /> : <SunIcon size={icon} />}
      </span>
    </button>
  );
}

function SunIcon({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="m4.93 4.93 1.41 1.41" />
      <path d="m17.66 17.66 1.41 1.41" />
      <path d="M2 12h2" />
      <path d="M20 12h2" />
      <path d="m6.34 17.66-1.41 1.41" />
      <path d="m19.07 4.93-1.41 1.41" />
    </svg>
  );
}

function MoonIcon({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
    </svg>
  );
}
